import TextInput from "../../../components/inputs/TextInput";
import RadioInput from "../../../components/inputs/RadioInput";
import RichTextInput from "../../../components/inputs/RichTextInput";
import EventImagesUpload from "../../../components/dashboard/EventImagesUpload";

const BasicInformationForm = ({ formData, setFormData, handleChange }) => {
  return (
    <form>
      <TextInput
        id="title"
        name="title"
        label="Title"
        value={formData?.title}
        onChange={handleChange}
        required={true}
        invalidMsg="Title is required!"
      />
      <TextInput
        id="subtitle"
        name="subtitle"
        label="Subtitle"
        value={formData?.subtitle}
        onChange={handleChange}
        required={true}
        invalidMsg="Subtitle is required!"
      />

      <RichTextInput
        value={formData.description}
        setFormData={setFormData}
        name="description"
        label="description"
      />

      <TextInput
        id="url"
        name="url"
        label="Event URL Path"
        value={formData.url}
        onChange={handleChange}
        required={true}
        invalidMsg="Event URL Path is required!"
      />
      <TextInput
        id="tags"
        name="tags"
        label="Tags"
        value={formData.tags}
        onChange={handleChange}
      />

      <RadioInput
        label="Visibility"
        name="visibility"
        value={formData.visibility}
        items={[
          {
            id: "public",
            value: "public",
            text: "Public (Accessible via homepage & direct link)",
          },
          {
            id: "private",
            value: "private",
            text: "Private (Only accessible by personal link)",
          },
        ]}
        onChange={handleChange}
      />

      <div>
        <label className="block text-base font-medium text-gray-700">
          {" "}
          Cover Image*
        </label>
        <EventImagesUpload
          fileInputName="imageFile"
          setFormData={setFormData}
          formData={formData}
        />
      </div>

      <div>
        <label className="block text-base font-medium text-gray-700">
          {" "}
          Banner Image*
        </label>
        <div className="mt-2 flex justify-center p-4 border-2 border-gray-300 border-dashed rounded-md">
          {formData.bannerData ? (
            <img
              className="mx-auto w-auto h-80"
              src={formData.bannerData}
              alt="Preview"
            />
          ) : (
            <svg
              className="mx-auto h-80 text-gray-400"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <EventImagesUpload
          fileInputName="bannerFile"
          setFormData={setFormData}
          formData={formData}
        />
      </div>

      <TextInput
        id="eventDate"
        name="eventDate"
        label="Event Date"
        value={formData.eventDate}
        onChange={handleChange}
        type="date"
        required={true}
        invalidMsg="Event Date is required!"
      />
    </form>
  );
};

export default BasicInformationForm;
